import { HTTP_TOKEN_REPORT } from "./http";

export const getReportHome = (params) => {
  return HTTP_TOKEN_REPORT.get("report-home", { params }).then((result) => {
    return result.data;
  });
};
